(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/cookies-check-and-info/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/components/cookies-check-and-info/assets/javascripts/init.js'); 
(function(svs) {
  'use strict';

  function init() {
    svs.components.cookies_check_and_info.cookieInfo.show();
  }

  function checkIfAskForThirdPartyCookiesAgain() {
    var thirdPartyCookiesAskAgainUrl = '/tredjepartscookies/kontrollera-igen',
      thirdPartyCookiesCampaignActive =
        svs.components.cookies_check_and_info.data.thirdPartyCookiesCampaign,
      thirdPartyCookiesCampaignVersion =
        svs.components.cookies_check_and_info.data
          .thirdPartyCookiesCampaignVersion,
      visitorThirdPartyCookiesAccepted = svs.components.cookies_check_and_info.dataHandler.getThirdPartyCookieAccepted(),
      visitorThirdPartyCookiesCampaignVersion = svs.components.IntroSettings.get(
        'third-party-cookies-campaign-version'
      ), 
      exposedToCampaignVersion = isNaN(
        parseInt(visitorThirdPartyCookiesCampaignVersion, 10)
      )
        ? false
        : visitorThirdPartyCookiesCampaignVersion >=
        thirdPartyCookiesCampaignVersion;

    if (
      thirdPartyCookiesCampaignActive &&
      !exposedToCampaignVersion &&
      !visitorThirdPartyCookiesAccepted
    ) {
      svs.components.IntroSettings.set(
        'third-party-cookies-campaign-version',
        thirdPartyCookiesCampaignVersion
      );
      if (window.location.href.indexOf(thirdPartyCookiesAskAgainUrl) < 0) {
        svs.utils.url.navigate(
          thirdPartyCookiesAskAgainUrl +
          '?returnUrl=' +
          encodeURIComponent(window.location.href)
        );
      }
    }
  }

  svs.components.cookies_check_and_info.checkIfAskForThirdPartyCookiesAgain = checkIfAskForThirdPartyCookiesAgain;

  $(function() {
    setTimeout(init, 1000);

  });
})(svs);

 })(window);